import { render, staticRenderFns } from "./SearchAgent.vue?vue&type=template&id=a59e27d2&scoped=true"
import script from "./SearchAgent.vue?vue&type=script&lang=js"
export * from "./SearchAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e27d2",
  null
  
)

export default component.exports